
import Vue from "vue";

export default Vue.extend({
  name: "ComprovantesPrint",
  data: () => ({
    //
  }),
  components: {
    //AppBar,
    // AppFooter,
  },
  mounted() {
    //this.loadingComponentOverlay = false;
  },
});
